/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendMonitoringMaterialProductPlanDto } from '../../models/backend-monitoring-material-product-plan-dto';

export interface MonitoringScenariosOpexesMaterialsList$Params {
  scenario_id: number;
}

export function monitoringScenariosOpexesMaterialsList(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringScenariosOpexesMaterialsList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendMonitoringMaterialProductPlanDto>>> {
  const rb = new RequestBuilder(rootUrl, monitoringScenariosOpexesMaterialsList.PATH, 'get');
  if (params) {
    rb.path('scenario_id', params.scenario_id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendMonitoringMaterialProductPlanDto>>;
    }),
  );
}

monitoringScenariosOpexesMaterialsList.PATH = '/api/monitoring/scenarios/{scenario_id}/opexes/materials/';
